import React from 'react'
import css from './NewPage.module.scss'
const PoperednijDohovir = () => {
  return (
      <>
           <h2 className={css.title}>Сторона фізична особа:</h2>
       <p className={css.text}>
              1.    Паспорт;
              </p>
                <p className={css.text}>
2.    Реєстраційний номер облікової картки платника податків;

Якщо фізична особа в шлюбі – згода подружжя на укладення попереднього договору див. Згода одного з подружжя на відчуження або придбання майна.
          </p>
                     <h2 className={css.title}>Сторона юридична особа:</h2>
          <p className={css.text}>
          
    -    Виписка з Єдиного державного реєстру юридичних осіб та фізичних осіб-підприємців (свідоцтво про державну реєстрацію);

              </p>
              <p className={css.text}>
                  -    Витяг з Державного реєстру юридичних осіб, фізичних осіб-підприємців (місячної давності);

</p>
              <p className={css.text}>
                    -    Статут;
            </p>
              <p className={css.text}>
                  -    Довідка з ЄДРПОУ (видається органами статистики);
              </p>
              <p className={css.text}>
                  -    Протокол/рішення, наказ про призначення посадової особи, яка уповноважена за статутом діяти без довіреності;

              </p>
              <p className={css.text}>
                  -    Якщо від імені юридичної особи діє представник, уповноважений за довіреністю – посвідчена нотаріально довіреність;

              </p>
              <p className={css.text}>
                  -    Якщо діє від імені юридичної особи керівник філії (відділення) – додатково аналогічний перелік документів по філії (відділенню);

              </p>
              <p className={css.text}>
                  -    Якщо укладення такого характеру договорів згідно статуту юридичної особи здійснюється зі згоди вищого органу – протокол загальних зборів вищого органу, в якому представнику юридичної особи надано згоду на укладення договору;

              </p>
              <p className={css.text}>
                  -   Паспорт підписанта;
</p>
              <p className={css.text}>
                  -   Печатка юридичної особи.
</p>
<p className={css.text}>
Для посвідчення попереднього договору нотаріусу надається інформація в усній формі про основні положення основного договору: термін укладення, розмірі завдатку, ціні, предметі та ін.
          </p>
    </>
  )
}

export default PoperednijDohovir
